import { Injectable } from '@angular/core';
import { HttpClient } from '@lib/network/http-client';
import { map } from 'rxjs/operators';
import { ApplicationVersion } from './application-version';

@Injectable()
export class ApplicationVersionRepository {
  constructor(private httpClient: HttpClient) {}

  currentVersion() {
    return this.httpClient
      .get('/application-versions')
      .pipe(map((response) => Object.assign(new ApplicationVersion(), response)));
  }
}
